"use strict";

exports.__esModule = true;
exports.APIProvider = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Auth = require("../Auth");
var _Env = require("../Env");
var _RealtimeConnection = require("./RealtimeConnection");
var _RestAPI = require("./RestAPI");
var _dec, _dec2, _class, _APIProvider;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Provides Rest API and RealtimeConnection contexts to consumers.
 */
var APIProvider = exports.APIProvider = (_dec = _Env.EnvContext.withContext, _dec2 = _Auth.AuthContext.withContext, _dec(_class = _dec2(_class = (_APIProvider = /*#__PURE__*/function (_Component) {
  function APIProvider() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      getCredentials: function getCredentials() {
        return {
          token: _this.props.auth.token,
          plantName: _this.props.plantName
        };
      },
      getWebSocket: function getWebSocket() {
        return new WebSocket(_this.props.env.websocketURL);
      },
      // eslint-disable-next-line react/no-unused-state
      websocketURL: _this.props.env.websocketURL
    };
    return _this;
  }
  _inheritsLoose(APIProvider, _Component);
  var _proto = APIProvider.prototype;
  _proto.render = function render() {
    //eslint-disable-next-line no-unused-vars
    var _this$props = this.props,
      auth = _this$props.auth,
      env = _this$props.env,
      plantName = _this$props.plantName,
      children = _this$props.children;
    var _this$state = this.state,
      getWebSocket = _this$state.getWebSocket,
      getCredentials = _this$state.getCredentials;
    return /*#__PURE__*/_react["default"].createElement(_RestAPI.RestAPIContext.Provider, {
      plantName: plantName
    }, /*#__PURE__*/_react["default"].createElement(_RealtimeConnection.RealtimeConnectionContext.Provider, {
      getWebSocket: getWebSocket,
      getCredentials: getCredentials
    }, children));
  };
  return APIProvider;
}(_react.Component), _APIProvider.defaultProps = {
  env: undefined,
  auth: undefined
}, _APIProvider)) || _class) || _class);